import { PaletteOptions } from "@mui/material";
import { PaletteType } from ".";

export const lightPalette: PaletteOptions = {
  mode: "light" as PaletteType,
  background: {
    default: "#ffffff",
    paper: "#ffffff",
  },
  primary: {
    main: "#00509D", // New main primary
    dark: "#003F7F", // Slightly darker version
    light: "#C2DFFF", // Light tint based on primary
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#C2F2FF", // New main secondary
    dark: "#A0DDEB", // Darker version
    light: "#E5FBFF", // Lighter tint
    contrastText: "#003F7F", // Ensures readable contrast
  },
  info: {
    main: "#F6F6F6",
    dark: "#EEEEEE",
    light: "#EBECEF",
  },
  text: {
    primary: "#000000",
    secondary: "#2F2F2F",
    disabled: "#B0B0B0",
  },
  success: {
    main: "#0CB277",
    light: "#0CB2771A",
    dark: "#CEEFE3",
    contrastText: "#044343",
  },
  green: {
    main: "#25B255",
    light: "#80DBBB",
    dark: "#1B8B44",
    contrastText: "#FFFFFF",
  },
  warning: {
    main: "#E02D17",
    dark: "#FF9000",
    light: "#FAC22D",
  },
  orange: {
    main: "#FF7900",
    light: "#FEA500",
    dark: "#F07B0F",
    contrastText: "#FDF1E7",
  },
  yellow: {
    main: "#B8860B",
    light: "#F7C55F1F",
    dark: "#F7C55F",
    contrastText: "",
  },
  error: {
    main: "#D32F2F",
    dark: "#CC1A36",
    light: "#EE8A87",
    contrastText: "#ED2939",
  },
  lightPurple: {
    main: "#F0ECFA",
    light: "#D4D3DC",
    dark: "#E7E4EF",
    contrastText: "#EDE7F9",
  },
  violet: {
    main: "#00509D", // Same as primary for consistency
    light: "#C2DFFF",
    dark: "#003F7F",
    contrastText: "#FFFFFF",
  },
  gray: {
    main: "#828282",
    light: "#E9E5F2",
    dark: "#222124",
    contrastText: "#555555",
  },
  customLightGrey: {
    main: "#F6F6F6",
    light: "#F0F0F0",
    dark: "#EEEDED",
    contrastText: "#D8D7D7",
  },
  customGrey: {
    main: "#DADADA",
    light: "#F9F9F9",
    dark: "#EDF2F4",
    contrastText: "#B9BBBF",
  },
  blue: {
    main: "#00509D", // Same as primary for consistency
    light: "#C2F2FF",
    dark: "#003F7F",
    contrastText: "#FFFFFF",
  },
  customBlue: {
    main: "#2D5BFF",
    light: "#2D5BFF1A",
    dark: "#EDF2F4",
    contrastText: "#FFFFFF",
  },
  neutral: {
    main: "#000000",
    light: "#FFFFFF",
    dark: "#BEBEBE",
    contrastText: "#3C454B",
  },
  common: {
    white: "#FFFFFF",
    black: "#000000",
  },
  border: {
    main: "#0000001A",
    contrastText: "",
    dark: "",
    light: "#0000001A",
  },
  divider: "#E0E0E0",
  lightgrey: {
    main: "#F2F4F7",
    light: "#E0E0E0",
    dark: "#505050",
    contrastText: "#F6F6F6",
  },
};

export const darkPalette: PaletteOptions = {
  mode: "dark" as PaletteType,
  background: {
    default: "#0D253F",
    paper: "#0b2b4d",
  },
  primary: {
    main: "#41D4FD",
    dark: "#3700B3",
    light: "#41D4FD1A",
    contrastText: "#000000",
  },
  secondary: {
    main: "#05192E",
    dark: "#030E1A",
    light: "#0D253F",
    contrastText: "#ffffff",
  },
  info: {
    main: "#282828",
    dark: "#363539",
  },
  text: {
    primary: "#fff",
    secondary: "#B0B0B0",
    disabled: "#6F6F6F",
  },
  success: {
    main: "#03A04F",
    light: "#214B39",
    dark: "#004D32",
  },
  green: {
    main: "#66BB6A",
    light: "#81C784",
    dark: "#338A3E",
    contrastText: "#FFFFFF",
  },
  warning: {
    main: "#FFA000",
    dark: "#C77800",
    light: "#FFC046",
  },
  orange: {
    main: "#FF6D00",
    light: "#FF8F00",
    dark: "#FF3D00",
    contrastText: "#FDF1E7",
  },
  yellow: {
    main: "#B8860B",
    light: "#F7C55F1F",
    dark: "#F7C55F",
    contrastText: "",
  },
  error: {
    main: "#d32f2f",
    dark: "#B00020",
    contrastText: "#ED2939",
  },
  violet: {
    main: "#9F67FF",
    light: "#110329",
    dark: "#3A167F",
    contrastText: "#ECEBFF",
  },
  lightPurple: {
    main: "#14022b",
    light: "#A28ACA",
    dark: "#3B2A5A",
    contrastText: "#DADADA",
  },
  gray: {
    main: "#b6b6b6",
    light: "#EBECEF",
    dark: "#05192e",
    contrastText: "#171717",
  },
  customLightGrey: {
    main: "#333333",
    light: "#4F4F4F",
    dark: "#1A1A1A",
    contrastText: "#E5E5E5",
  },
  customGrey: {
    main: "#424242",
    light: "#0b2b4d",
    dark: "#212121",
    contrastText: "#B9BBBF",
  },
  blue: {
    main: "#90CAF9",
    light: "#2D5BFF",
    dark: "#1A237E",
    contrastText: "#FFFFFF",
  },
  customBlue: {
    main: "#2DA8FF",
    light: "#2D5BFF1A",
    dark: "#EDF2F4",
    contrastText: "#fff",
  },
  neutral: {
    main: "#FFFFFF",
    light: "#333333",
    dark: "#BEBEBE",
    contrastText: "#1E1E1E",
  },
  common: {
    white: "#FFFFFF",
    black: "#000000",
  },

  border: {
    main: "#0D253F",
    contrastText: "",
    dark: "",
    light: "#FFFFFF80",
  },

  divider: "#FFFFFF80",
  lightgrey: {
    main: "#0D253F",
    light: "",
    dark: "",
    contrastText: "",
  },
};
